import "zone.js/dist/zone"; // Included with Angular CLI.
(window as any).global = window;
